module.exports = __webpack_public_path__ + "img/slide_03_en.d9299471.jpg";